(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-gf-pdp]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('.gf-pdp-cart-form');
      const variants = JSON.parse(root.querySelector('[data-pdp-variants]').textContent);
      const definition = root.querySelector('[data-pdp-personalizer-data]');
      const personalizer = definition ? JSON.parse(definition.textContent) : null;
      const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: root.dataset.currency || 'USD' }).format(cents / 100);
      const savedPersonalizations = new Map();
      let selected = variants.find(v => String(v.id) === form.querySelector('[data-pdp-variant]').value) || variants[0];
      const optionSets = [...root.querySelectorAll('[data-option-index]')];
      const packSet = root.querySelector('[data-pack-option]');
      const packQty = v => packSet ? Math.max(1, parseInt(v.options[Number(packSet.dataset.optionIndex)], 10) || 1) : 1;
      const frames = [...root.querySelectorAll('[data-pdp-images] > [data-media-id]')];
      const galleryMain = root.querySelector('[data-pdp-images]');
      const galleryThumbs = root.querySelector('.pdp-gallery__thumbs');
      const rail = root.querySelector('[data-pdp-thumbs]');
      const syncThumbNavigation = () => {
        if (!rail) return;
        root.querySelectorAll('[data-pdp-thumb-scroll]').forEach(button => {
          button.hidden = Number(button.dataset.pdpThumbScroll) < 0 ? rail.scrollTop <= 1 : rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 1;
        });
      };
      if (galleryMain && galleryThumbs) new ResizeObserver(() => {
        const vertical = matchMedia('(min-width:768px)').matches;
        const height = `${Math.min(632, galleryMain.clientHeight)}px`;
        galleryThumbs.style.height = vertical ? height : '';
        if (rail) rail.style.maxHeight = vertical ? height : '';
        syncThumbNavigation();
      }).observe(galleryMain);
      const thumbs = [...root.querySelectorAll('[data-pdp-thumb]')];
      let imageIndex = 0;
      const showImage = index => {
        imageIndex = (index + frames.length) % frames.length;
        frames.forEach((frame, i) => { frame.hidden = i !== imageIndex; if (i !== imageIndex) frame.querySelector('video')?.pause(); });
              thumbs.forEach((thumb, i) => { thumb.classList.toggle('swiper-slide-thumb-active', i === imageIndex); thumb.setAttribute('aria-pressed', String(i === imageIndex)); });
        const count = root.querySelector('[data-pdp-image-count]');
        if (count) count.textContent = `${imageIndex + 1} / ${frames.length}`;
        const rail = root.querySelector('[data-pdp-thumbs]');
        const thumb = thumbs[imageIndex];
        if (rail && thumb) {
          if (window.matchMedia('(min-width:768px)').matches) rail.scrollTop = thumb.offsetTop - rail.offsetTop;
          else rail.scrollLeft = thumb.offsetLeft - rail.offsetLeft;
        }
      };
      let swipeStart = null;
      let swipedUntil = 0;
      galleryMain.addEventListener('pointerdown', event => { if (event.pointerType === 'touch') swipeStart = [event.clientX, event.clientY]; });
      galleryMain.addEventListener('pointercancel', () => { swipeStart = null; });
      galleryMain.addEventListener('pointerup', event => {
        if (!swipeStart) return;
        const dx = event.clientX - swipeStart[0], dy = event.clientY - swipeStart[1]; swipeStart = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.2) { showImage(imageIndex + (dx < 0 ? 1 : -1)); swipedUntil = Date.now() + 350; }
      });
      root.querySelector('[data-pdp-gallery]').addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); showImage(imageIndex + (event.key === 'ArrowRight' ? 1 : -1)); }
      });
      thumbs.forEach((thumb, i) => thumb.addEventListener('click', () => showImage(i)));
      root.querySelectorAll('[data-pdp-image-step]').forEach(button => button.addEventListener('click', () => showImage(imageIndex + Number(button.dataset.pdpImageStep))));
      rail?.addEventListener('scroll', syncThumbNavigation, { passive: true });
      root.querySelectorAll('[data-pdp-thumb-scroll]').forEach(button => button.addEventListener('click', () => {
        rail?.scrollBy({ top: Number(button.dataset.pdpThumbScroll) * 320, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      root.querySelectorAll('[data-pdp-zoom]').forEach(button => button.addEventListener('click', () => {
        if (Date.now() < swipedUntil) return;
        const dialog = document.getElementById('GiftyLightbox');
        if (!dialog) return;
        const source = button.querySelector('img');
        const img = dialog.querySelector('img');
        img.src = source.currentSrc || source.src; img.alt = source.alt;
        dialog.showModal();
      }));
      const renderPersonalizer = () => {
        if (!personalizer || !root.querySelector('[data-pdp-fields]')) return;
        const host = root.querySelector('[data-pdp-fields]');
        const total = personalizer.repeatPack ? packQty(selected) : 1;
        [...host.querySelectorAll('input')].filter(i => i.type !== 'radio' || i.checked).forEach(i => savedPersonalizations.set(i.name, i.value));
        const values = savedPersonalizations;
        host.replaceChildren();
        for (let n = 1; n <= total; n++) {
          const group = document.createElement('details'); group.className = 'gf-pers-group'; group.open = true;
          const summary = document.createElement('summary');
          const counter = document.createElement('span'); counter.className = 'gf-pers-number'; counter.textContent = n;
          summary.append(counter, document.createTextNode(`${personalizer.group} ${n}`));
          const caret = root.querySelector('[data-pdp-caret-icon]');
          if (caret) summary.append(caret.content.cloneNode(true));
          group.append(summary);
          const body = document.createElement('div'); body.className = 'gf-pers-fields';
          personalizer.fields.forEach((field, f) => {
            if (field.whenOption && !selected.options.some(o => o.includes(field.whenOption))) return;
            const box = document.createElement('fieldset'); box.className = 'gf-pers-field';
            const label = document.createElement('legend'); label.className = 'gf-pers-label';
            label.textContent = `${field.label}${personalizer.repeatPack ? ` #${n}` : ''} *`; box.append(label);
            const name = `properties[${field.label}${personalizer.repeatPack ? ` #${n}` : ''}]`;
            if (field.inputs[0]?.type === 'text') {
              const input = document.createElement('input'); input.type = 'text'; input.name = name;
              input.id = `${root.dataset.sectionId}-personal-${n}-${f}`; input.required = true; input.className = 'gf-pers-text';
              input.setAttribute('aria-label', label.textContent); input.maxLength = field.inputs[0].maxlength > 0 ? field.inputs[0].maxlength : 50;
              input.placeholder = field.inputs[0].placeholder || 'Enter your text here'; input.value = values.get(name) || '';
              box.append(input);
            } else {
              const row = document.createElement('div'); row.className = 'gf-pers-swatches';
              field.inputs.forEach((value, i) => {
                const wrapper = document.createElement('label'); wrapper.className = 'gf-pers-swatch'; wrapper.title = value.value;
                const input = document.createElement('input'); input.type = 'radio'; input.name = name; input.value = value.value; input.required = true;
                input.checked = values.has(name) ? values.get(name) === value.value : i === 0;
                input.setAttribute('aria-label', `${field.label}: ${value.value}`);
                const chip = document.createElement('span'); chip.className = 'gf-pers-chip';
                if (value.color && value.color !== 'transparent') chip.style.setProperty('--swatch-color', value.color);
                else if (value.image) { const image = document.createElement('img'); image.src = value.image; image.alt = value.value; image.width = 46; image.height = 46; image.loading = 'lazy'; chip.append(image); }
                else { chip.classList.add('gf-pers-chip--text'); chip.textContent = value.value; }
                wrapper.append(input, chip); row.append(wrapper);
              }); box.append(row);
            }
            body.append(box);
          }); group.append(body); host.append(group);
        }
        root.querySelector('[data-pdp-personalizer]').hidden = false;
      };
      const updateVariant = (changeUrl = true) => {
        const options = optionSets.map(set => set.querySelector('input:checked')?.value);
        optionSets.forEach((set, index) => {
          if (index === 0) return;
          const matches = variants.filter(v => v.available && v.options.slice(0, index).every((o, i) => o === options[i]));
          if (matches.length && !matches.some(v => v.options[index] === options[index])) {
            options[index] = matches[0].options[index];
            set.querySelectorAll('input').forEach(input => input.checked = input.value === options[index]);
          }
        });
        const variant = optionSets.length ? variants.find(v => v.options.every((o, i) => options[i] === o)) : selected;
        const button = form.querySelector('[data-pdp-add]');
        optionSets.forEach((set, index) => {
          set.querySelectorAll('input').forEach(input => {
            const available = variants.some(v => v.available && v.options[index] === input.value && v.options.slice(0, index).every((o, i) => o === options[i]));
            input.disabled = !available && !input.checked;
          });
        });
        button.disabled = !variant?.available;
        (button.querySelector('[data-pdp-add-label]') || button).textContent = variant ? (variant.available ? 'Add to cart' : 'Sold out') : 'Unavailable';
        if (!variant) return;
        selected = variant;
        form.querySelector('[data-pdp-variant]').value = variant.id;
        form.querySelector('[data-pdp-variant]').dispatchEvent(new Event('change', { bubbles: true }));
        root.querySelector('[data-pdp-price]').textContent = money(variant.price);
        const compare = root.querySelector('[data-pdp-compare]'); const off = root.querySelector('[data-pdp-off]');
        compare.hidden = off.hidden = !(variant.compare_at_price > variant.price);
        compare.textContent = money(variant.compare_at_price || 0);
        if (!off.hidden) off.textContent = `-${Math.floor((1 - variant.price / variant.compare_at_price) * 100)}% OFF`;
        if (changeUrl) { const url = new URL(window.location.href); url.searchParams.set('variant', variant.id); history.replaceState({}, '', url); }
        if (variant.featured_media) { const index = frames.findIndex(frame => String(variant.featured_media.id) === frame.dataset.mediaId); if (index >= 0) showImage(index); }
        renderPersonalizer();
        root.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant } }));
      };
      optionSets.forEach(set => set.addEventListener('change', updateVariant));
      if (packSet) {
        const index = Number(packSet.dataset.optionIndex);
        const packs = [...new Set(variants.map(v => v.options[index]))].map(value => variants.find(v => v.options[index] === value && v.available));
        const list = root.querySelector('[data-pdp-volume-list]');
        packs.filter(Boolean).forEach(variant => {
          const value = variant.options[index];
          root.querySelectorAll('[data-pdp-pack-price]').forEach(e => { if (e.dataset.pdpPackPrice === value) e.textContent = `${money(variant.price / packQty(variant))}/pc`; });
          const percent = variant.compare_at_price > variant.price ? Math.floor((1 - variant.price / variant.compare_at_price) * 100) : 0;
          root.querySelectorAll('[data-pdp-pack-save]').forEach(e => { if (e.dataset.pdpPackSave === value) { e.textContent = `Save ${percent}%`; e.hidden = !percent; } });
          if (!percent) return;
          const item = document.createElement('li'); item.className = 'bmsm__row';
          const icon = document.createElement('span'); icon.className = 'bmsm__icon'; icon.append(root.querySelector('[data-pdp-gift-icon]').content.cloneNode(true)); item.append(icon);
          [['bmsm__qty', `Buy ${packQty(variant)}`], ['bmsm__off', `Get ${percent}% Off`]].forEach(([c, text]) => { const e = document.createElement('span'); e.className = c; e.textContent = text; item.append(e); }); list.append(item);
        }); root.querySelector('[data-pdp-volume]').hidden = list.children.length < 2;
      }
      const dates = d => { const date = new Date(); date.setDate(date.getDate() + d); return date.toLocaleDateString('en-US', { month: 'long', day: '2-digit' }); };
      const range = root.querySelector('[data-pdp-delivery-range]');
      if (range) range.textContent = `${dates(Number(root.dataset.deliveryMin) || 5)} - ${dates(Number(root.dataset.deliveryMax) || 12)}`;
      root.querySelectorAll('[data-pdp-date]').forEach(e => e.textContent = dates(Number(e.dataset.pdpDate)));
      root.querySelectorAll('[data-pdp-quantity]').forEach(button => button.addEventListener('click', () => {
        const input = form.querySelector('[name="quantity"]');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + Number(button.dataset.pdpQuantity)); input.dispatchEvent(new Event('change', { bubbles: true }));
      }));
      form.addEventListener('submit', async event => {
        // When an activated personalization app owns submission, preserve its checkout handler.
        if (form.querySelector('.customily-main-app')) return;
        event.preventDefault(); if (!form.reportValidity()) return;
        const button = form.querySelector('[data-pdp-add]'); const error = form.querySelector('[data-pdp-error]');
        error.hidden = true; button.disabled = true; (button.querySelector('[data-pdp-add-label]') || button).textContent = 'Adding…';
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
          const result = await response.json(); if (!response.ok) throw new Error(result.description || 'Unable to add this item. Please try again.');
          form.querySelector('[data-pdp-added]').hidden = false;
          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`); const cart = await cartResponse.json();
          document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = cart.item_count);
          document.querySelectorAll('.gf-actions a[href$="/cart"]').forEach(e => { const text = e.querySelector('span'); if (text) text.textContent = `Cart (${cart.item_count})`; });
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart, open: true } }));
        } catch (err) { error.textContent = err.message; error.hidden = false; }
        finally { button.disabled = !selected.available; (button.querySelector('[data-pdp-add-label]') || button).textContent = selected.available ? 'Add to cart' : 'Sold out'; }
      });
      updateVariant(false);
      if (!optionSets.length && selected.featured_media) { const i = frames.findIndex(f => f.dataset.mediaId === String(selected.featured_media.id)); if (i >= 0) showImage(i); }
    });
    scope.querySelectorAll('[data-gf-pdp-related]').forEach(async root => {
      if (root.dataset.initialized) return; root.dataset.initialized = 'true';
      try { const html = await (await fetch(root.dataset.url)).text(); const doc = new DOMParser().parseFromString(html, 'text/html'); const result = doc.querySelector('[data-pdp-recommended-cards]'); if (result?.children.length) root.querySelector('[data-pdp-recommended-cards]').innerHTML = result.innerHTML; } catch (_) { /* Server-rendered collection cards remain available. */ }
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init()); else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
